import { H6 } from 'components/Typography';
import styled, { css } from 'styled-components';
import { CloseButton } from 'components/Button';
import { FaUpload } from 'react-icons/fa';
import { th } from 'style/theme';

export const DeleteBtn = styled(CloseButton)`
  display: none;
`;

export const UploadedText = styled(H6)`
  font-size: 16px;

  > svg {
    color: ${th('colors.bermudaGreen')};
    position: relative;
    margin-left: 4px;
    top: 2px;
  }

  ${({ $display }) =>
    !$display &&
    css`
      :hover {
        ${DeleteBtn} {
          display: inline-block;
          margin-left: 4px;
        }

        > svg {
          display: none;
        }
      }
    `}
`;

export const UploadIcon = styled(FaUpload)`
  margin-right: 5px;
  font-size: 14px;
`;
